import { withAsyncLoading } from '../../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableFormationDetailsPdfPage = withAsyncLoading(async () => import('./FormationDetailsPdfPage').then((res) => res.FormationDetailsPdfPage));

export { LoadableFormationDetailsPdfPage };
